const ApiRootUrl = "https://www.kejiaoshu.com:8080/"
const imgServer = 'https://robot'
module.exports = {
  MapKey: 'QEHBZ-AAURX-TEF4L-TFHSC-JRFEV-UFBFJ',
  PictureServer: {
    Info: imgServer + 'i-1305194676.cos.ap-guangzhou.myqcloud.com/',
    Log: imgServer + 'l-1305194676.cos.ap-guangzhou.myqcloud.com/',
	Forum: imgServer + 'f-1305194676.cos.ap-guangzhou.myqcloud.com/',
  },
  imgServer: imgServer,
  login: ApiRootUrl + 'swebBackstage/toLogin', 
  getComNames: ApiRootUrl + 'theapis/getComName'
};


// WEBPACK FOOTER //
// ./src/api/api.js